import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { IIcon } from './icon.interface';
import { TransformSportToIconNamePipe } from '../../../shared/pipe/sportToIconName/sport-to-icon-name.pipe';

@Component({
    selector: 'mlp-ng-icon',
    templateUrl: './icon.component.html',
    styleUrls: ['./icon.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class IconSharedComponent {
    @Input() size?: IIcon['size'] = 'default';
    @Input() animation?: string;
    private _name: IIcon['name'];
    @Input('name') set setIconName(value: string) {
        this._name = value.replace(' ', '-');
    }

    constructor(private transformSportToIconName: TransformSportToIconNamePipe) { }

    get name(): string { return this.transformSportToIconName.transform(this._name); }
}
